import React, { lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import AppliedRoute from '../components/AppliedRoute';
import ProtectedRoute from '../components/ProtectedRoute';
import NotFound from './site/NotFound';
import AdminDashboard from './dashboards/AdminDashboard';
import ConfirmEmail from './site/ConfirmEmail';
import ResetPassword from './site/ResetPassword';
import AccountDashboard from './dashboards/AccountDashboard';
import ChangePassword from './usermanagement/ChangePassword';
import AccountingDashboard from './dashboards/AccountingDashboard';
import Login from './site/Login';
import Dashboard from './dashboards/Dashboard';

const Admin = ['Admin'];
const Accounting = ['Accounting', 'Executive', 'Admin'];
const Manager = ['Manager', 'Accounting', 'Executive', 'Admin'];

const CreditCardDashboard = lazy(() => import('./creditCards/CreditCardDashboard'));
const GLMapManager = lazy(() => import('./creditCards/GLMapManager'));

const MobileShopTimesheet = lazy(() => import('./shop/MobileShopTimesheet'));
const ShopDashboard = lazy(() => import('./shop/ShopDashboard'));
const ValidateImportedParts = lazy(() => import('./shop/ValidateImportedParts'));

const DesktopTimesheets = lazy(() => import('./timesheets/DesktopTimesheets'));
const MobileTimesheets = lazy(() => import('./timesheets/MobileTimesheets'));
const MobileExpenseReports = lazy(() => import('./expenses/MobileExpenseReports'));
const DesktopExpenses = lazy(() => import('./expenses/DesktopExpenses'));

const Approvals = lazy(() => import('./approvals/Approvals'));

const ProjectData = lazy(() => import('./bom/ProjectData'));
const ProjectValidate = lazy(() => import('./bom/ProjectValidate'));

const JobDashboard = lazy(() => import('./jobs/JobDashboard'));
const JobCosting = lazy(() => import('./jobs/JobCosting'));

const ManageUsers = lazy(() => import('./usermanagement/ManageUsers'));

const SchedulerDashboard = lazy(() => import('./scheduler/SchedulerDashboard'));
const MobileScheduler = lazy(() => import('./scheduler/MobileScheduler'));

const BillRatesDashboard = lazy(() => import('./usermanagement/billRates/BillRatesDashboard'));

const ShopClock = lazy(() => import('./shop/ShopClock'));
const ShopClockManager = lazy(() => import('./shop/ShopClockManager'));
const SoDashboard = lazy(() => import('./saleOrder/SODashboard'));
const PODashboard = lazy(() => import('./purchaseOrders/PODashboard'));

export default function Routes({ childProps, isAuthenticated }) {
  return (
    <Switch>
      {/* Un-Authorized Routes */}
      <AppliedRoute path='/Login' exact component={Login} props={childProps} />
      <AppliedRoute path='/ConfirmEmail' exact component={ConfirmEmail} props={childProps} />
      <AppliedRoute path='/ResetPassword' exact component={ResetPassword} props={childProps} />
      <AppliedRoute
        path='/api/*'
        exact
        component={(props) => <Redirect to={props.location.pathname + (props.location.search ? props.location.search : '')} />}
        props={childProps}
      />

      {/* User (Authorized) Routes */}
      <ProtectedRoute path='/' exact component={Dashboard} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/Dashboard' exact component={Dashboard} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/ProjectData' exact component={ProjectData} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/ProjectValidate' exact component={ProjectValidate} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/Account' exact component={AccountDashboard} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/ChangePassword' exact component={ChangePassword} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/Expenses' exact component={DesktopExpenses} mobileComponent={MobileExpenseReports} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/Timesheet' exact component={DesktopTimesheets} mobileComponent={MobileTimesheets} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/ShopTimesheet' exact component={MobileShopTimesheet} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/Shop' exact component={ShopDashboard} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/Shop/Validate' exact component={ValidateImportedParts} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/MySchedule' exact component={MobileScheduler} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/CreditCards' exact component={CreditCardDashboard} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/Approvals' exact component={Approvals} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/ShopClock' exact component={ShopClock} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/ShopClockManager' exact component={ShopClockManager} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/PODashboard' exact component={PODashboard} props={childProps} isAuthenticated={isAuthenticated} />

      {/* Manager (Authorized) Routes */}
      <ProtectedRoute path='/SchedulerDashboard' exact component={SchedulerDashboard} props={childProps} isAuthenticated={isAuthenticated} roles={Manager} />
      <ProtectedRoute path='/JobDashboard' exact component={JobDashboard} props={childProps} isAuthenticated={isAuthenticated} roles={Manager} />
      <ProtectedRoute path='/SODashboard' exact component={SoDashboard} props={childProps} isAuthenticated={isAuthenticated} />
      <ProtectedRoute path='/JobCosting' exact component={JobCosting} props={childProps} isAuthenticated={isAuthenticated} roles={Manager} />

      {/* Accounting (Authorized) Routes */}
      <ProtectedRoute path='/ManageGLMap' exact component={GLMapManager} props={childProps} isAuthenticated={isAuthenticated} roles={Accounting} />
      <ProtectedRoute path='/AccountingDashboard' exact component={AccountingDashboard} props={childProps} isAuthenticated={isAuthenticated} roles={Accounting} />
      <ProtectedRoute path='/BillRates' exact component={BillRatesDashboard} props={childProps} isAuthenticated={isAuthenticated} roles={Accounting} />

      {/* Admin (Authorized) Routes */}
      <ProtectedRoute path='/AdminDashboard' exact component={AdminDashboard} props={childProps} isAuthenticated={isAuthenticated} roles={Admin} />
      <ProtectedRoute path='/ManageUsers' exact component={ManageUsers} props={childProps} isAuthenticated={isAuthenticated} roles={Admin} />

      {/* Not-Found Routes */}
      <Route component={NotFound} />
    </Switch>
  );
}
